export const HEADER_SECTION_HANDLE = "product-collections-header";
export const GRID_SECTION_HANDLE = "product-collections-subcollection";

export const FILTER_ROOT_SELECTOR = "[data-collection-filters]";

export const NAV_LINK_SELECTOR = "[data-js-subcollection-nav]";

export const SECTION_FETCH_SKIP_PARAMS = new Set(["page", "section_id", "sections"]);

export const HISTORY_SKIP_PARAMS = new Set(["section_id", "sections"]);
